module.exports = __webpack_public_path__ + "static/media/blog-image-1.40775253.svg";